import { createAsyncThunk } from "@reduxjs/toolkit";
import { CommonAxiosResponse, RootState, thunkResponseHandler } from "common";
import { UserAffiliateApi } from "./api";
import {
  GetUserAffiliateTotalIncentivesResponse,
  GetUserAffiliateVouchersResponse,
} from "./types";
import { pickBy } from "lodash";

export const getUserAffiliateVouchersThunk = createAsyncThunk<
  CommonAxiosResponse<GetUserAffiliateVouchersResponse>,
  undefined
>("UserAffiliate/getUserAffiliateVouchersThunk", async () => {
  const res = await UserAffiliateApi.getUserAffiliateVouchers();
  const toThunk = thunkResponseHandler(res);
  return toThunk;
});

export const getUserAffiliateDetailsThunk = createAsyncThunk<
  CommonAxiosResponse<GetUserAffiliateTotalIncentivesResponse>,
  undefined,
  { state: RootState }
>("UserAffiliate/getUserAffiliateDetailsThunk", async (_, api) => {
  const request = api?.getState()?.UserAffiliate.getUserAffiliateDetailsPayload;
  const cleanedRequest = pickBy(
    request,
    (value) => value !== "" && value !== null && value !== undefined
  );
  const user_uuid = api?.getState()?.PcwUserProfile?.userProfileData?.uuid;

  let totalIncentivesRes =
    await UserAffiliateApi.getUserAffiliateTotalIncentives({
      ...cleanedRequest,
      user_uuid,
    });

  if (!totalIncentivesRes?.ok) {
    throw new Error("Failed to at getUserAffiliateDetailsThunk.");
  }

  const totalCustomerRes =
    await UserAffiliateApi.getUserAffiliateTotalCustomers({
      ...cleanedRequest,
      user_uuid,
    });

  if (totalCustomerRes?.ok && totalIncentivesRes?.data?.data) {
    totalIncentivesRes.data.data.total_customers =
      totalCustomerRes?.data?.data?.total_customers || 0;
  } else {
    throw new Error("Failed to at getUserAffiliateDetailsThunk.");
  }

  const totalDiscountRes = await UserAffiliateApi.getUserAffiliateTotalDiscount(
    {
      ...cleanedRequest,
      user_uuid,
    }
  );
  if (totalDiscountRes?.ok && totalDiscountRes?.data?.data) {
    totalIncentivesRes.data.data.total_discount =
      totalDiscountRes?.data?.data?.total_discount || 0;
  } else {
    throw new Error("Failed to at getUserAffiliateDetailsThunk.");
  }

  const toThunk = thunkResponseHandler(totalIncentivesRes);
  return toThunk;
});
